/** Shared visual values for React Native surfaces in every client host. */
export const uiColors = {
  light: {
    background: "#F8F8F8",
    surface: "#FFFFFF",
    subtle: "#F0F0F0",
    text: "#202020",
    muted: "#656565",
    border: "#E6E6E6",
    controlBorder: "#D4D4D4",
    navigation: "#F8F8F8",
    navigationText: "#303030",
    navigationMuted: "#686868",
    navigationSelected: "#EAEAEA",
    navigationBorder: "#E6E6E6",
    shadow: "#000000",
    danger: "#B91C1C",
    primary: "#202020",
    onPrimary: "#FFFFFF",
    accent: "#2957C8",
    onAccent: "#FFFFFF",
    accentSoft: "#2957C80D",
  },
  dark: {
    background: "#141414",
    surface: "#1D1D1D",
    subtle: "#292929",
    text: "#F3F3F3",
    muted: "#B5B5B5",
    border: "#323232",
    controlBorder: "#505050",
    navigation: "#141414",
    navigationText: "#F3F3F3",
    navigationMuted: "#ACACAC",
    navigationSelected: "#303030",
    navigationBorder: "#303030",
    shadow: "#000000",
    danger: "#FCA5A5",
    primary: "#EFEFEF",
    onPrimary: "#141414",
    accent: "#94B5FF",
    onAccent: "#121212",
    accentSoft: "#94B5FF20",
  },
};

export const uiMetrics = {
  radius: { sm: 6, md: 8, lg: 12 },
  control: { height: 40, compactHeight: 32, touchHeight: 44 },
} as const;
